import { render, staticRenderFns } from "./MerchantCreate.vue?vue&type=template&id=2b6c0606&scoped=true&"
import script from "./MerchantCreate.vue?vue&type=script&lang=js&"
export * from "./MerchantCreate.vue?vue&type=script&lang=js&"
import style0 from "./MerchantCreate.vue?vue&type=style&index=0&id=2b6c0606&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6c0606",
  null
  
)

export default component.exports